import { Box } from "@mui/material";

export const AbstractPageContent: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <Box
      id="teams"
      sx={{
        pb: 9,
        maxWidth: 1200,
        mx: "auto",
        mt: 4,
        paddingInline: { xs: 1, sm: 0 },
      }}
    >
      {children}
    </Box>
  );
};
